/**
 * 营运中心--》短途接驳-新增
 */

export default {
  // 取消未填短驳费 确认弹框
  no_fill_short_lighter_confirm: ["97993"], // 202506032359507832880
  // 发站网点，到站全部
  short_lighter_all_site: ["98300"], // 202511061451246176143
};
